export const PAGINATION_PER_PAGE = 10;

export const COMPLETION_STEP: Record<number, string> = {
  0: "Registered",
  1: "Completed Profile Info",
  2: "Completed Customized Info",
  3: "Completed Development Targets",
  4: "Onboarded",
};

export const ALLOW_REFUND_USERS_COUNT =
  window.location.origin.includes("staging") ||
  window.location.origin.includes("localhost")
    ? 3
    : 10;
